import BulkCashManagementComponent from './bulk_cash_management.component';
import PrintBulkCashModule from './print';

let bulkCashManagementModule = angular.module('bulkCashManagement', [PrintBulkCashModule])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/bulk-cash');

    $stateProvider
      .state('bulkCashManagement', {
        url: '/bulk-cash',
        component: 'bulkCashManagement',
        data: {
          requireLogin: true,
          requireACL: 'bulk_cash_management.all,view'
        },
        parent: 'app',
      });
  })

  .component('bulkCashManagement', BulkCashManagementComponent)

  .name;

export default bulkCashManagementModule;


// WEBPACK FOOTER //
// ./client/app/components/bulk_cash_management/index.js